// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"aacecc40960e7f4cffb4","9249":"f154f0536c3ad8526757"}[chunkId] + ".chunk.js";
};